import { InputType } from './../../../../../shared/enums/input-type/input-type.module';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { MatDialog } from '@angular/material/dialog';
import { AfterViewChecked, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ElementType } from '../../../../../shared/enums/element-type/element-type.module';
import { Block } from '../../../../../models/block.model';
import { ComponentsGroup } from '../../../../../models/componentGroup.model';
import { Component as ComponentModel } from '../../../../../models/component.model';
import { ElementCopied } from '../../../../../models/elementCopied.model';
import { LocalStorageService } from '../../../../../services/shared/local-storage/local-storage.service';
import { InsertTextDialogComponent } from '../../../../../shared/components/insert-text-dialog/insert-text-dialog.component';
import { SnackbarService } from '../../../../../services/shared/snackbar/snackbar.service';
import { UtilsService } from '../../../../../services/shared/utils/utils.service';
import { Page } from '../../../../../models/page.model';
import { CommonService } from '../../../../../services/shared/common/common.service';
import { ComponentType } from '../../../../../shared/enums/component-type/component-type.module';
import { SelectType } from '../../../../../shared/enums/select-type/select-type.module';

@Component({
  selector: 'app-page-config-elem-menu',
  templateUrl: './page-config-elem-menu.component.html',
  styleUrl: './page-config-elem-menu.component.css'
})
export class PageConfigElemMenu implements OnChanges {

  ElementType = ElementType;
  element: (Block | ComponentsGroup | ComponentModel | undefined);

  @Input() elementType!: ElementType;
  @Input() copiedElements!: ElementCopied[];
  @Input() page!: Page;
  @Input() selectedBlock!: Block | null;
  @Input() selectedGroup!: ComponentsGroup | null;
  @Input() selectedComponent!: ComponentModel | null;

  ComponentType = ComponentType;

  @Output() copyAction = new EventEmitter<ElementCopied[]>();
  @Output() clearAction = new EventEmitter();
  @Output() pasteAction = new EventEmitter<{ newComponentIds?: string[], newBlockId?: string, lastIndex?: number }>();

  constructor(private translationService: TranslationService,
    private lStorage: LocalStorageService,
    private dialog: MatDialog,
    private snackBar: SnackbarService,
    private utils: UtilsService,
    private commonService: CommonService) {
  }

  hasSomethingToPaste = false;
  existOnList = false;

  pasteableElements: any[] = [];

  title = "";

  buildTitle()
  {
    var elementTypeString = this.translationService.translate(ElementType[this.elementType].toString());
    var componentTypeString = "";
    if(this.elementType == ElementType.COMPONENT && this.selectedComponent)
    {
      componentTypeString += this.selectedComponent.type == ComponentType.CHECKBOX ? "CHOICE_BUTTON" : ComponentType[this.selectedComponent.type!].toString();
      if(this.selectedComponent.config!.inputType != undefined)
      {
        componentTypeString += "_" + InputType[this.selectedComponent.config!.inputType].toString();
      }
      else if(this.selectedComponent.config!.selectType != undefined)
      {
        componentTypeString += "_" + SelectType[this.selectedComponent.config!.selectType].toString();
      }

      componentTypeString = " - " + this.translationService.translate(componentTypeString);
    }

    this.title = elementTypeString + componentTypeString;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.actionChangePasteableElementsList();
  }

  avaliate()
  {
    if(this.elementType == ElementType.PAGE)
    {
      this.hasSomethingToPaste = this.existCopiedElementsByType(ElementType.BLOCK);
    }
    else if(this.elementType == ElementType.BLOCK)
    {
      this.hasSomethingToPaste = this.existLowerHierarchyCopiedElements(this.elementType);
      if(this.selectedBlock)
      {
        this.element = structuredClone(this.selectedBlock);
      }
    }
    else if(this.elementType == ElementType.GROUP)
    {
      this.hasSomethingToPaste = this.existLowerHierarchyCopiedElements(this.elementType);
      if(this.selectedGroup)
      {
        this.element = structuredClone(this.selectedGroup);
      }
    }
    else if(this.elementType == ElementType.COMPONENT)
    {
      this.hasSomethingToPaste = this.existCopiedElementsByType(this.elementType);
      if(this.selectedComponent)
      {
        this.element = structuredClone(this.selectedComponent);
      }
    }

    this.existOnList = this.existOnCopiedElements();
  }

  actionChangePasteableElementsList() {
    setTimeout(() => {
      this.avaliate();
      this.buildTitle();
      this.pasteableElements = this.copiedElements.map(element => ({
        ...element,
        isDisabled: this.isPasteDisabled(element, this.elementType)
      }));
    }, 0);
  }
  copyElement(type: ElementType){

    if(!this.element)
      return;

    if(this.copiedElements.some(x => x.data.id == this.element!.id))
    {
      this.snackBar.showWarning(this.translationService.translate("You already have this element copied!"));
      return;
    }

    const dialogRef = this.dialog.open(InsertTextDialogComponent, {
      width: '500px',
      data: { title: this.translationService.translate("Element name"), subtitle: this.translationService.translate("Insert a name for the copied element") }
    });

    dialogRef.afterClosed().subscribe(name => {
      if(name != undefined)
      {
        var subname = "";
        if(this.copiedElements.some(x => x.name == name))
        {
          var count = this.copiedElements.filter(x => x.name == name).length+1;
          subname = "(" + count + ")";
        }

        var newElementCopied: ElementCopied = {
          name: name,
          subname: subname,
          type: type,
          data: this.element!
        }
        this.copiedElements.push(newElementCopied);

        //update or create copiedElements
        const now = new Date();
        const tomorrowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        this.lStorage.setItemWithExpiryAt('copiedElements', JSON.stringify(this.copiedElements), tomorrowMidnight);

        var message = this.translationService.translate("Element copied");
        this.snackBar.showCustom(message, 'content_copy');

        this.copyAction.emit(this.copiedElements);
        this.actionChangePasteableElementsList();
      }
    });
  }
  pasteElement(elementPasted: ElementCopied, pastedZoneType: ElementType){
    if(elementPasted.type == ElementType.BLOCK && pastedZoneType == ElementType.PAGE && this.page)
    {
      const copiedElement = { ...elementPasted.data } as Block;
      var newBlock = this.blockDeepCopy(copiedElement);

      if (this.page !== null) {
        this.page.blocks!.push(newBlock);
        const lastIndex = this.page.blocks!.length - 1;

        var newBlockId = newBlock.id;
        var newComponentIds = newBlock.componentGroups.flatMap(group => group.components).map(comp => comp.id);

        this.pasteAction.emit({newComponentIds: newComponentIds, newBlockId: newBlockId, lastIndex: lastIndex});
        this.avaliate();
      }
    }
    else if(elementPasted.type == ElementType.GROUP && pastedZoneType == ElementType.BLOCK && this.selectedBlock)
    {
      const copiedElement = { ...elementPasted.data } as ComponentsGroup;
      var newGroup = this.groupDeepCopy(copiedElement);

      this.selectedBlock.componentGroups.push(newGroup);

      var newComponentIds = newGroup.components.map(comp => comp.id);
      this.pasteAction.emit({newComponentIds: newComponentIds, newBlockId: undefined, lastIndex: undefined});
      this.avaliate();
    }
    else if(elementPasted.type == ElementType.COMPONENT && pastedZoneType <= ElementType.BLOCK)
    {
      const copiedElement = { ...elementPasted.data } as ComponentModel;
      var newComponent = this.componentDeepCopy(copiedElement);

      if(pastedZoneType == ElementType.BLOCK && this.selectedBlock)
      {
        //create group for component
        const groupWithMaxOrder = this.selectedBlock.componentGroups.length > 0 ? this.selectedBlock.componentGroups.reduce((prev, current) => (prev.order! > current.order!) ? prev : current).order : -1;
        var groupOrder = groupWithMaxOrder! +1;
        var newGroup = this.commonService.buildNewGroup(groupOrder);

        newGroup.components.push(newComponent);
        this.selectedBlock.componentGroups.push(newGroup);
      }
      else if((pastedZoneType == ElementType.GROUP || pastedZoneType == ElementType.COMPONENT) && this.selectedGroup)
      {
        const componentWithMaxOrder = this.selectedGroup.components.reduce((prev, current) => (prev.order! > current.order!) ? prev : current);
        newComponent.order = componentWithMaxOrder ? componentWithMaxOrder.order! +1 : 0;
        this.selectedGroup.components.push(newComponent);
      }

      var newComponentIds = [newComponent.id];
      this.pasteAction.emit({newComponentIds: newComponentIds, newBlockId: undefined, lastIndex: undefined});
      this.avaliate();
    }
    else{
      this.snackBar.showError(this.translationService.translate("Error on paste this element"));
    }
  }
  componentDeepCopy(copiedElement: ComponentModel): ComponentModel
  {
    return {
      ...copiedElement,
      id: this.utils.generateGUID(),
      config: {
        ...copiedElement.config,
        options: copiedElement.config?.options || [],
        conditionComponentTarget: undefined,
        conditionPosition: undefined
      },
      conditions: [],
      connections: copiedElement.connections || [],
      roles: (copiedElement.roles || []).map(role => ({
        ...role,
        accessibility: { ...role.accessibility }
      })),
      multipleConfig: {
        ...copiedElement.multipleConfig,
        initQuantity: copiedElement.multipleConfig?.initQuantity ?? 0,
        minQuantity: copiedElement.multipleConfig?.minQuantity ?? 0
      },
      keyIndicator: { weight: copiedElement.keyIndicator?.weight ?? 0 },
      order: 0
    };
  }
  groupDeepCopy(copiedElement: ComponentsGroup): ComponentsGroup
  {
    const groupWithMaxOrder =
      this.selectedBlock!.componentGroups.length > 0 ?
      this.selectedBlock!.componentGroups.reduce((prev, current) => (prev.order! > current.order!) ? prev : current).order
      : -1;

    return {
      id: this.utils.generateGUID(),
      order: groupWithMaxOrder! +1,
      components: copiedElement.components.map(component => this.componentDeepCopy(component)),
      multipleConfig: {
        ...copiedElement.multipleConfig,
        initQuantity: copiedElement.multipleConfig?.initQuantity ?? 0,
        minQuantity: copiedElement.multipleConfig?.minQuantity ?? 0
      }
    };
  }
  blockDeepCopy(copiedElement: Block): Block
  {
    return {
      ...copiedElement,
      id: this.utils.generateGUID(),
      conditions: [],
      roles: (copiedElement.roles || []).map(role => ({
        ...role,
        accessibility: { ...role.accessibility }
      })),
      componentGroups: copiedElement.componentGroups.map(group => this.groupDeepCopy(group))
    };
  }
  clearElements(){
    if(this.copiedElements.length > 0)
    {
      this.copiedElements = [];
      localStorage.removeItem('copiedElements');
      this.clearAction.emit();
      this.avaliate();
    }
  }

  existLowerHierarchyCopiedElements(type: ElementType): boolean {
    return this.copiedElements.some((element) => element.type < type);
  }
  existCopiedElementsByType(type: ElementType): boolean
  {
    return this.copiedElements.some((element) => element.type == type);
  }
  existOnCopiedElements(): boolean{
    if(this.copiedElements.length == 0)
    {
      return false;
    }

    if(this.elementType == ElementType.BLOCK && this.selectedBlock != null)
    {
      return this.copiedElements.some((element) => element.data.id == this.selectedBlock!.id);
    }
    else if(this.elementType == ElementType.GROUP && this.selectedGroup != null)
    {
      return this.copiedElements.some((element) => element.data.id == this.selectedGroup!.id);
    }
    else if(this.elementType == ElementType.COMPONENT && this.selectedComponent != null)
    {
      return this.copiedElements.some((element) => element.data.id == this.selectedComponent!.id);
    }
    else
    {
      return false;
    }
  }
  isPasteDisabled(element: ElementCopied, elementType: ElementType): boolean {
    return (
      (elementType === ElementType.PAGE && element.type !== ElementType.BLOCK) ||
      (elementType === ElementType.BLOCK && element.type >= ElementType.BLOCK) ||
      (elementType === ElementType.GROUP && element.type >= ElementType.GROUP) ||
      (elementType === ElementType.COMPONENT && element.type > ElementType.COMPONENT)
    );
  }
}
